'use client';

import { useAuthMe } from '@/features/user';
import { hasActiveZangiaPlus } from '@/features/jobs/lib/hasActiveZangiaPlus';
import { UserDTO } from '@/shared/user/user.dto';

export function useHasActiveZangiaPlus(userOverride?: UserDTO | null) {
  const {
    data: authUser,
    isAuthLoading: isAuthMeLoading, 
  } = useAuthMe();
  const usesOverride = userOverride !== undefined;
  const user = usesOverride ? userOverride : authUser;

  return {
    user,
    isAuthLoading: usesOverride ? false : isAuthMeLoading,
    hasPlus: hasActiveZangiaPlus(user), 
  };
}
